import React from 'react'

const Grocerytopratedlist = () => {
    return (
        <div>

        </div>
    )
}

export default Grocerytopratedlist
